/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {
    RepeatableScreensManagerDeps,
    RepeatableScreensManager
} from '../../../shared/step/repeatable-screen-manager.class';
import {WorkService} from '../../../../domain/model/work/history/work.service';
import {Observable} from 'rxjs';
import {Step} from '../../../../components/sections/service/step.class';

@Injectable()
export class WorkHistoryScreensManager extends RepeatableScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _workService: WorkService) {
        super(rsmm);
    }

    init(step: Step) {
        super.init(step);
        this._workService.changes$.switchMap(() => this.refresh()).subscribe(() => {});
    }

    protected _countEntries(): Observable<number> {
        return this._workService.countCurrentUserModelEntries();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/work/steps/history/work-history-screens-manager.service.ts